module.exports = require('./lib/linkify-html').default;



// WEBPACK FOOTER //
// ./node_modules/linkifyjs/html.js